import * as React from 'react';
import Box from '@mui/material/Box';
import { Button, Card, CardContent, CardMedia, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import header from '../../assets/header.jpg';

export default function Home() {

    let history = useNavigate();
    const matches = useMediaQuery('(min-width:600px)');

    return (
        <Box className='masthead'>
            <Box sx={{ width: '100%', p: 2, mt: matches ? 20 : 4 }}>
                <Card sx={{ width: matches ? 600 : 360, m: '0 auto', pt: 2, pb: 2 }}>
                    <Typography align='center' fontSize={20} color='black'>
                        Welcome to T1A
                    </Typography>
                    <CardMedia
                        component="img"
                        height="200"
                        image={header}
                        alt="green iguana"
                    />
                    <CardContent>
                        <Typography paragraph sx={{ p: 2, textAlign:'justify' }} color='black'>
                            T1A is Europe’s leading refurbisher with more than 4000 m² production and warehouse facilities
                            with 20 years of experience. We take great pride in our strict grading policy, and are Blancco certified Gold Partner and Microsoft authorized refurbisher.
                            Prior to any sales, our products go through rigorous
                            testing to make sure that our customers receive only 100% fully
                            functioning products with zero to minimal signs of usage.
                        </Typography>
                        <Button variant="contained" onClick={() => history('/lookup')} sx={{ color: 'white', ml: 2 }}>
                            Lookup
                        </Button>
                        <Button variant="contained" onClick={() => history('/activation')} sx={{ color: 'white', ml: 2 }}>
                            Activation
                        </Button>
                    </CardContent>
                </Card>

            </Box>
        </Box>
    );
}
